import apiClient from '../apiClient';
import { POST_IMAGE_TRANSPORTATION_UNIT_URL } from '../apiUrl';

const postUploadImageTransportationUnitApi = (Id, data) => {
  return apiClient.post(POST_IMAGE_TRANSPORTATION_UNIT_URL(Id), data);
};

export default postUploadImageTransportationUnitApi;
